export const phonenumberValidator = phonenumber => {
  if (!phonenumber) {
    return "شماره همراه خود را وارد کنید";
  } else if (!new RegExp(/(0|\+98)?([ ]|-|[()]){0,2}9[1|2|3|4]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/).test(phonenumber)) {
    return "شماره همراه وارد شده صحیح نمیباشد";
  }
  return "";
};

export const passwordValidator = password => {
  if (!password) {
    return "*";
  } else if (!new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/).test(password)) {
    return "لطفا برای ساختن رمز عبور مطمئن، موارد زیر را رعایت کنید: \n اندازه آن حداقل 8 کاراکتر باشد.\n حداقل یک حرف (a-z).\n حداقل یک حرف بزرگ (A-Z).\n حداقل یک علامت (!@#...)\n حداقل یک عدد";
  }
  return "";
};

export const usernameValidator = username => {

  if (!username) {
    return "*";
  } else if (!new RegExp(/^[A-Za-z][A-Za-z0-9]*$/).test(username)) {
    return "شامل حروف انگلیسی باشد.";
  }
  return "";
};

export const firstnameValidator = firstname => {

  if (!firstname) {
    return "*";
  } else if (!new RegExp(/^[آ-ی ء چ]+.{1,}$/).test(firstname)) {
    return "از نام فارسی استفاده کنین و حداقل دارای دو حرف باشد";
  }
  return "";
};

export const lastnameValidator = lastname => {

  if (!lastname) {
    return "*";
  } else if (!new RegExp(/^[آ-ی ء چ]+.{1,}$/).test(lastname)) {
    return "از نام فارسی استفاده کنین و حداقل دارای دو حرف باشد";
  }
  return "";
};

export const captchaValidator = captcha => {

  if (!captcha) {
    return "*";
  } else if (captcha.length < 2) {
    return "*";
  }
  return "";
};

export const nameValidator = name => {
  if (!name) {
    return "*";
  } else if (name.length < 2) {
    return "*";
  }
  return "";
};

export const englishNameValidator = english_name => {
  if (!english_name) {
    return "*";
  } else if (english_name.length < 2) {
    return "*";
  }
  return "";
};

export const addressValidator = address => {
  if (!address) {
    return "*";
  } else if (address.length < 2) {
    return "*";
  }
  return "";
};

export const locationValidator = location => {
  if (!location) {
    return "*";
  } else if (location.length < 2) {
    return "*";
  }
  return "";
};

export const timeValidator = time => {
  if (!time) {
    return "*";
  } else if (time.length < 2) {
    return "*";
  }
  return "";
};

  // export const confirmPasswordValidator = (confirmPassword, form) => {
  //   if (!confirmPassword) {
  //     return "Confirm password is required";
  //   } else if (confirmPassword.length < 8) {
  //     return "Confirm password must have a minimum 8 characters";
  //   } else if (confirmPassword !== form.password) {
  //     return "Passwords do not match";
  //   }
  //   return "";
  // };